// Static conversion rates relative to 1 CHF (Swiss Franc)
// Key: ISO currency code, Value: amount of target currency per 1 CHF
// Source: user-provided table (used as a fallback/reference only)

export const CHF_CONVERSIONS: Record<string, number> = {
    USD: 1.24,
    CAD: 1.74,
    MXN: 23.06,
    CLP: 1173.32,
    BRL: 6.70,
    ARS: 1798.72,
    AWG: 2.24,
    BSD: 1.24,
    BBD: 2.49,
    BZD: 2.51,
    BMD: 1.24,
    BOB: 8.62,
    CVE: 118.97,
    KYD: 1.04,
    XPF: 128.64,
    COP: 4816.17,
    KMF: 529.82,
    CRC: 625.88,
    CUC: 1.24,
    CUP: 32.03,
    DOP: 80.19,
    XCD: 3.36,
    FKP: 0.946,
    GTQ: 9.57,
    GYD: 261.10,
    HTG: 163.24,
    HNL: 32.83,
    JMD: 200.30,
    ANG: 2.23,
    NIO: 45.93,
    PAB: 1.24,
    PYG: 8828.81,
    PEN: 4.22,
    SHP: 0.946,
    SVC: 10.92,
    SRD: 47.89,
    TTD: 8.45,
    UYU: 49.59,
    VES: 275.44,
    NGN: 1807.74,
    DZD: 161.65,
    AOA: 1134.24,
    BWP: 16.76,
    BIF: 3662.17,
    XOF: 707.10,
    XAF: 707.10,
    CLF: 0.03,
    CDF: 2860.42,
    DJF: 222.24,
    EGP: 58.73,
    ERN: 18.66,
    ETB: 192.27,
    GMD: 90.17,
    GHS: 13.60,
    GNF: 10832.30,
    KES: 160.69,
    LSL: 21.64,
    LRD: 227.84,
    LYD: 6.81,
    MGA: 5604.99,
    MWK: 2163.99,
    MRO: 444.01,
    MUR: 57.15,
    MAD: 11.56,
    MZN: 79.47,
    NAD: 21.64,
    PGK: 5.26,
    RWF: 1812.70,
    STD: 27712.23,
    STN: 26.43,
    SCR: 18.48,
    SLL: 26080.11,
    SOS: 713.27,
    ZAR: 21.51,
    SSP: 162.01,
    SDG: 748.10,
    SZL: 21.64,
    TZS: 3070.07,
    UGX: 4346.99,
    ZMW: 27.61,
    ZWL: 400.48,
    AUD: 1.90,
    NZD: 2.17,
    BHD: 0.469,
    AED: 4.57,
    ILS: 4.05,
    JOD: 0.882,
    KZT: 660.81,
    KWD: 0.382,
    LBP: 111807.25,
    OMR: 0.478,
    QAR: 4.55,
    WST: 3.47,
    SAR: 4.66,
    SBD: 10.24,
    TOP: 2.99,
    TND: 3.66,
    UZS: 14981.91,
    VUV: 151.34,
    YER: 296.63,
    BGN: 2.11,
    EUR: 1.08,
    GBP: 0.946,
    NOK: 12.57,
    RUB: 99.50,
    UAH: 52.31,
    PLN: 4.59,
    ALL: 104.49,
    BYN: 4.25,
    BAM: 2.11,
    HRK: 8.12,
    CZK: 26.23,
    DKK: 8.05,
    GIP: 0.946,
    GGP: 0.946,
    HUF: 417.89,
    ISK: 156.09,
    JEP: 0.946,
    MKD: 66.42,
    IMP: 0.946,
    MDL: 21.02,
    RON: 5.48,
    RSD: 126.36,
    SEK: 11.80,
    TRY: 52.30,
    BTC: 0.000012,
    CNY: 8.85,
    JPY: 191.77,
    SGD: 1.62,
    PKR: 353.40,
    HKD: 9.67,
    KRW: 1777.35,
    THB: 40.30,
    INR: 110.42,
    AFN: 83.25,
    AMD: 477.31,
    AZN: 2.11,
    BDT: 152.51,
    BTN: 110.64,
    BND: 1.62,
    MMK: 2611.43,
    KHR: 5004.01,
    CNH: 8.85,
    FJD: 2.82,
    GEL: 3.38,
    IDR: 20754.22,
    IRR: 52329.36,
    IQD: 1634.89,
    KGS: 108.76,
    LAK: 26981.51,
    MOP: 9.99,
    MYR: 5.22,
    MVR: 19.03,
    MNT: 4464.69,
    NPR: 177.02,
    TWD: 38.33,
    KPW: 1119.34,
    PHP: 73.15,
    LKR: 379.95,
    SYP: 16170.80,
    TJS: 11.49,
    TMT: 4.35,
    VND: 32712.15,
};


